module.exports = __webpack_public_path__ + "img/contact.41d1e3a2.jpg";